import { Box } from '@mui/material';
import type { SparkDiagnosticsMetaPublishChecklist } from 'types/Spark/SparkDiagnostics';
import SparkHealthActions from './SparkHealthActions';
import { numericSort } from 'utilities/sort';
import SparkSectionHeader from '../SparkSectionHeader';

type RequiredProps = {
  requiredActions: SparkDiagnosticsMetaPublishChecklist['required'];
};

function Required({ requiredActions }: RequiredProps) {
  const sortedRequiredActions = requiredActions.sort((a, b) =>
    numericSort(a.sortOrder, b.sortOrder)
  );

  return (
    <Box>
      <SparkSectionHeader
        headerText='Required'
        subHeaderText="Check that you've completed all the required information"
      />
      <SparkHealthActions
        actions={sortedRequiredActions}
        containerStyles={{ ml: 2, mt: 2 }}
      />
    </Box>
  );
}

export default Required;
